<template>
    <div>
        <div class="flex items-center justify-between">
            <breadcrumbs>Werkzoekenden</breadcrumbs>
        </div>

        <h1 class="text-5xl text-teal-800">Werkzoekenden</h1>

        <div class="flex justify-between items-center mb-5">
            <div class="flex flex-col">
                <search-filter v-model="form.search" class="w-full max-w-sm mr-4" @reset="reset" @input="submitSearch">
                    <label class="block text-grey-darkest">Account aangemaakt:</label>
                    <select v-model="form.filter_verified" class="mt-1 w-full form-select" @change="reloadData">
                        <option :value="null" />
                        <option value="yes">Ja</option>
                        <option value="no">Nee</option>
                    </select>

                    <label class="block text-grey-darkest mt-2">Heeft alerts:</label>
                    <select v-model="form.filter_has_alerts" class="mt-1 w-full form-select" @change="reloadData">
                        <option :value="null" />
                        <option value="yes">Ja</option>
                        <option value="no">Nee</option>
                    </select>
                </search-filter>

                <active-filters :filters="filters" @remove-filter="removeFilter" />
            </div>

            <num-results name="gebruikers"
                         :from="users.from"
                         :to="users.to"
                         :total="users.total"
            />

            <input type="hidden" v-model="form.orderBy" />
            <input type="hidden" v-model="form.sortOrder" />
        </div>

        <p v-if="!users.data.length">Er zijn geen users gevonden.</p>

        <table v-if="users.data.length" class="w-full whitespace-no-wrap bg-white rounded">
            <thead>
                <tr class="text-teal-800 font-bold">

                    <th class="px-3 py-3 text-left whitespace-nowrap">
                        <a href @click.prevent="sort('id')" class="hover:underline">ID<sort-icon col="id" :orderby="filters.orderBy" :sortorder="filters.sortOrder" /> </a>
                    </th>
                    <td class="px-3 py-3 whitespace-nowrap">
                        <a href @click.prevent="sort('created_at')" class="hover:underline whitespace-nowrap">
                            <i class="fal fa-calendar-plus mr-1"></i>Created<sort-icon col="created_at" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </td>

                    <td class="px-3 py-3 text-center">
                        Image
                    </td>

                    <td class="px-3 py-3 whitespace-nowrap">
                        <a href @click.prevent="sort('first_name')" class="hover:underline">
                            First&nbsp;name<sort-icon col="first_name" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </td>

                    <td class="px-3 py-3 whitespace-nowrap">
                        <a href @click.prevent="sort('last_name')" class="hover:underline">
                            Last name<sort-icon col="last_name" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </td>

                    <td class="px-3 py-3 whitespace-nowrap">
                        <a href @click.prevent="sort('email')" class="hover:underline">
                            E-mail<sort-icon col="email" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </td>

<!--                    <td class="px-3 py-3 whitespace-nowrap">-->
<!--                        Tel-->
<!--                    </td>-->

                    <td ></td>
                </tr>
            </thead>

            <tr
                v-for="(user, index) in users.data"
                :key="user.id"
                class="hover:text-teal-900 hover:bg-teal-300 focus-within:bg-teal-300 :text-teal-900"
                :class="{ 'bg-teal-100': !(index % 2), 'text-gray-500': user.deleted_at }"
            >
                <!-- <td class="border-t" width="10">
                    <span v-if="user.deleted_at" class="text-gray-500 mx-5"><i class="fad fa-trash mr-1"></i></span>
                </td> -->

                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:font-bold" :href="route('admin.users.show', user.id)" tabindex="-1">
                        {{ user.id }}
                    </inertia-link>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center" :href="route('admin.users.show', user.id)" tabindex="-1">
                        <div v-if="user.created_at">
                            {{ moment(user.created_at).format("DD-MM-YYYY") }}
                        </div>
                    </inertia-link>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="flex items-center focus:text-teal-800 truncate justify-center" :href="route('admin.users.show', user.id)">
                        <img v-if="user.avatar" :src="user.avatar" alt="" class="h-10 rounded-full" />
                    </inertia-link>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex focus:text-teal-800 truncate" :href="route('admin.users.show', user.id)">
                        {{ user.first_name }}
                    </inertia-link>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.users.show', user.id)">
                        {{ user.last_name }}
                    </inertia-link>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.users.show', user.id)">
                        {{ user.email }}
                    </inertia-link>
                </td>

<!--                <td class="px-3 border-t">-->
<!--                    <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.users.show', user.id)">-->
<!--                        {{ user.phone }}-->
<!--                    </inertia-link>-->
<!--                </td>-->

                <td class="px-3 border-t whitespace-nowrap">
                    <i v-if="user.email_verified_at === null" class="fal fa-user-circle mr-1 text-gray-400"></i>
                    <i v-else class="fas fa-user-circle mr-1" title="account aangemaakt"></i>
                </td>

                <td class="px-3 border-t whitespace-nowrap">
                    <div v-if="user.alerts_count > 0" class="relative">
                        <i class="fal fa-bell"></i>
                        <span class="text-xs absolute -top-1 -right-1">{{ user.alerts_count }}</span>
                    </div>
                </td>

                <td class="text-right pr-5 border-t whitespace-nowrap">
                    <div v-if="!user.deleted_at">
                        <link-button :href="route('admin.users.edit', user.id)" icon="pencil" class="hover:bg-white"></link-button>
                        <confirm-button method="delete" :href="route('admin.users.destroy', user.id)" icon="trash" class="bg-white hover:bg-red-600 hover:text-white"></confirm-button>
                    </div>
                </td>
            </tr>
        </table>

        <pagination :links="users.links" />
    </div>
</template>

<script>
import _ from "lodash";
import Layout from "@/admin/Shared/Layout";
import SortIcon from "@/admin/Shared/SortIcon";
import Pagination from "@/admin/Shared/Pagination";
import SearchFilter from "@/admin/Shared/SearchFilter";
import ActiveFilters from "@/admin/Shared/ActiveFilters";
import NumResults from "@/admin/Shared/NumResults";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import LinkButton from "@/admin/Shared/LinkButton";
import SimpleButton from "@/admin/Shared/SimpleButton";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import ConfirmButton from "@/admin/Shared/ConfirmButton";


export default {
    metaInfo: { title: "Gebruikers" },

    layout: Layout,

    remember: "form",

    mixins: [Helpers],

    components: {
        Pagination,
        SearchFilter,
        ActiveFilters,
        SortIcon,
        NumResults,
        Breadcrumbs,
        LinkButton,
        SimpleButton,
        ConfirmButton
    },

    props: {
        users: Object,
        filters: Object
    },
    data() {
        return {
            form: {
                trashed: this.filters.trashed,
                active: this.filters.active,
                search: this.filters.search,
                orderBy: this.filters.orderBy,
                sortOrder: this.filters.sortOrder
            }
        };
    },
    methods: {
        deleteUsers(user) {
            this.$inertia.delete(this.route("admin.users.destroy", user.id), {
                preserveScroll: true
            });
        },

        reloadData() {
            let queryParams = _.pickBy(this.form);
            this.$inertia.get(this.route('admin.users.index', Object.keys(queryParams).length ? queryParams : {remember: 'forget' }), {}, { preserveState: true })
        },

        sort(col) {
            this.form.sortOrder = this.getNewSortOrder(col, this.form.orderBy, this.form.sortOrder);
            this.form.orderBy = col;
            this.reloadData();
        },

        submitSearch: _.debounce(function() {
            this.reloadData();
        }, 250),

        reset() {
            this.form = _.mapValues(this.form, () => null);
            this.reloadData();
        },

        removeFilter(filterName) {
            this.form[filterName] = null;
            this.reloadData();
        }
    }
};
</script>
